<template>
  <div>
    <b-card
      :img-src="img_src"
      img-alt="Card image"
      img-top
      class="interest-card-mid"
    >
      <b-row>
        <b-col lg="8" md="8"
          ><b-card-text>
            {{ title }}
          </b-card-text></b-col
        >
        <b-col lg="4" md="4" class="col-actions-mid text-right"
          ><b-button variant="action" class="m-0"
            ><img
              src="@/assets/images/my-irish-date/edit-action.png"
              alt="mid icon"
              @click="clickEditInterest(id)" /></b-button
          ><b-button variant="action" class="m-0 delete-btn"
            ><img
              src="@/assets/images/my-irish-date/delete-action-icon.png"
              alt="mid icon"
              @click="clickDeleteInterest(id)"
          /></b-button>
        </b-col>
      </b-row>
    </b-card>
  
  </div>
</template>

<script>
export default {
  name: "SingleInterest",
  props: ["id", "title", "img_src", "client_name"],
  components: {},
  data() {
    return {
      interest_id: null,
    };
  },
  mounted() {
    // console.log(this.title, " --- ", this.question);
    // this.question = this.title;
  },
  methods: {
    clickDeleteInterest(id) {
      this.$parent.$parent.clickDeleteInterest(id)
    },
    clickEditInterest(id){
      this.$parent.$parent.clickEditInterest(id)
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/my_irish_date/interests_describe/SingleInterest.vue